import { contact } from '../../portfolio'
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null

  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>Get In Touch</h2>
      <p className='contact__description'>
        Let&apos;s work together on your next project.
      </p>
      <div className='contact__info'>
        <a href={`mailto:${contact.email}`} className='contact__item'>
          <span className='contact__icon'>✉️</span>
          <span className='contact__text'>{contact.email}</span>
        </a>
        {contact.phone && (
          <a href={`tel:${contact.phone}`} className='contact__item'>
            <span className='contact__icon'>📞</span>
            <span className='contact__text'>{contact.phone}</span>
          </a>
        )}
      </div>
    </section>
  )
}

export default Contact
